import React from "react"

import Tag from "./Tag"

export default ({ tags, activeTags, onTagClick }) => {
  const active = activeTags === undefined ? [] : activeTags
  return (
    <div className="tags">
      {tags && tags.map((tagItem) => {

        const { slug, title, category } = tagItem.node === undefined ? tagItem : tagItem.node
        const isActive = active.indexOf(slug) >= 0
        
        return (
          <Tag
            key={slug}
            slug={slug}
            category={category}
            title={title}
            onTagClick={onTagClick}
            selected={isActive}
          />
        )
      })}
    </div>
  )
}